import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('leads-receptions', storeModule.createStoreModule('leads-receptions'))
